import { render, staticRenderFns } from "./SyncRoleList.vue?vue&type=template&id=74256870&"
import script from "./SyncRoleList.vue?vue&type=script&lang=js&"
export * from "./SyncRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports